// Module
var code = "<a class=\"link-type-control-data\" data-bind=\"attr: {href: _value ? _value : undefined}, css: {disabled: !_value}, tooltip: {content: _value}\" target=\"_blank\"> <i class=\"icon\" data-bind=\"css : {[_icon || 'fa fa-link'] : true}, style: {'color': _labelStyle}\"></i> </a>";
// Exports
export default code;